import { OwnerOnboardingProvider } from "./components/ownerOnboarding";
import { Help } from "./pages/administration/sections/help";
//import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//Sections
import Admin from "./pages/administration";
//Components
import { Dashboard } from "./pages/administration/sections/dashboard";
import { Carts } from "./pages/administration/sections/carts";
import { Orders } from "./pages/administration/sections/orders";
import { Products } from "./pages/administration/sections/products";
import { Catalogs } from "./pages/administration/sections/catalogs";
import { Attributes } from "./pages/administration/sections/attributes";
import { Categories } from "./pages/administration/sections/categories";
import { SalesChannel } from "./pages/administration/sections/salesChannel";
import { Clients } from "./pages/administration/sections/clients";
import { Discounts } from "./pages/administration/sections/discounts";
import { Configuration } from "./pages/administration/sections/configuration";
import Login from "./pages/login";
import RecoverPassword from "./pages/login/recoverPassword";
import { ProtectedRoute } from "./components/security/protectedRoute";
//Functions
import packageJson from "../package.json";
import Initializer from "./hooks/initializer";
import { useNavigationSync } from "./hooks/useNavigationSync";
import { useLogoutSync } from "./hooks/useLogout";
import { Asistente } from "./pages/administration/sections/asistente";
import { LoaderComponent } from "./components/loaderComponent";
import { useSelector, shallowEqual } from "react-redux";

const SessionAndNavigationSync = () => {
  useLogoutSync();
  useNavigationSync();
  return null;
};

const Navigation = () => {
  // Con shallowEqual evitamos renders si el booleano no cambia (aunque para boolean no es crítico)
  const logged = useSelector(
    (state) => state.aplicationConfig.userConfig.logged,
    shallowEqual,
  );
  return (
    <Router>
      {!logged && <LoaderComponent /> /* Loader fullscreen solo para login */}
      <Initializer />
      <SessionAndNavigationSync />

      <OwnerOnboardingProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/createpassword/:token" element={<RecoverPassword />} />
        <Route path="/change-password/:token" element={<RecoverPassword />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute page="dashboard">
              <Admin component={<Dashboard />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute page="clients">
              <Admin component={<Clients />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/salesChannel"
          element={
            <ProtectedRoute page="salesChannel">
              <Admin component={<SalesChannel />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute page="orders">
              <Admin component={<Orders />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/carts"
          element={
            <ProtectedRoute page="carts">
              <Admin component={<Carts />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute page="products">
              <Admin component={<Products />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <ProtectedRoute page="categories">
              <Admin component={<Categories />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/attributes"
          element={
            <ProtectedRoute page="attributes">
              <Admin component={<Attributes />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalogs"
          element={
            <ProtectedRoute page="catalogs">
              <Admin component={<Catalogs />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/discounts"
          element={
            <ProtectedRoute page="discounts">
              <Admin component={<Discounts />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration"
          element={
            <ProtectedRoute page="configuration">
              <Admin component={<Configuration />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/help"
          element={
            <ProtectedRoute>
              <Admin component={<Help />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/asistente"
          element={
            <ProtectedRoute page="asistente">
              <Admin component={<Asistente />} />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Login />} />
      </Routes>
      </OwnerOnboardingProvider>
    </Router>
  );
};

function App() {
  return (
    <>
      <div className="appVersion">
        {packageJson.version +
          "/" +
          packageJson.dependencies["@delibrandev/utils"].replace("^", "")}
      </div>
      <Navigation />
    </>
  );
}

export default App;
